import type { ActionExecutor } from "../TriggerEngine.interfaces";

export const micMute: ActionExecutor = async (
  radio,
  config,
  { emitAction, eventContext },
) => {
  const targetId = config?.deviceId;

  if (targetId && targetId !== "__all__") {
    if (!radio.Microphones.get(targetId) &&
        !radio.Microphones.getActiveMicrophones().includes(targetId)) {
      throw new Error("The target microphone no longer exists");
    }

    await radio.Microphones.stop(targetId, eventContext);

    if (radio.Microphones.getActiveMicrophones().includes(targetId)) {
      throw new Error("Could not mute the target microphone");
    }

    emitAction("mic_state_changed", { deviceId: targetId, active: false });
  } else {
    const activeMics = radio.Microphones.getActiveMicrophones();

    for (const deviceId of activeMics) {
      await radio.Microphones.stop(deviceId, eventContext);

      if (radio.Microphones.getActiveMicrophones().includes(deviceId)) {
        throw new Error("Could not mute the target microphone");
      }

      emitAction("mic_state_changed", { deviceId, active: false });
    }
  }
};

export const micUnmute: ActionExecutor = async (
  radio,
  config,
  { emitAction, eventContext },
) => {
  const targetId = config?.deviceId;

  if (targetId && targetId !== "__all__") {
    const mic = radio.Microphones.get(targetId);

    if (!mic) throw new Error("The target microphone no longer exists");

    await radio.Microphones.play(
      mic.deviceInfo.deviceId,
      mic.capabilities,
      eventContext,
    );

    if (!radio.Microphones.getActiveMicrophones().includes(mic.deviceInfo.deviceId)) {
      throw new Error("Could not activate the target microphone");
    }

    emitAction("mic_state_changed", {
      deviceId: mic.deviceInfo.deviceId,
      active: true,
    });
  } else {
    const allMics = radio.Microphones.getAll();

    if (allMics.length === 0) throw new Error("No microphones are available");

    const activeMics = new Set(radio.Microphones.getActiveMicrophones());

    for (const mic of allMics) {
      if (!activeMics.has(mic.deviceInfo.deviceId)) {
        await radio.Microphones.play(
          mic.deviceInfo.deviceId,
          mic.capabilities,
          eventContext,
        );

        if (!radio.Microphones.getActiveMicrophones().includes(mic.deviceInfo.deviceId)) {
          throw new Error("Could not activate the target microphone");
        }

        emitAction("mic_state_changed", {
          deviceId: mic.deviceInfo.deviceId,
          active: true,
        });
      }
    }
  }
};
